import state from './categoryState'
import mutations from './categoryMutations'
import actions from './categoryActions'
import getters from './categoryGetters'

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
